// extracted by mini-css-extract-plugin
module.exports = {"team":"Team-styles_team__3CYVf"};